/**
 * Mapbox transformRequest helper. Uses path-prefix matching for relative API
 * endpoints (e.g. "/api") so we do not treat "https://api.mapbox.com" as ours.
 */
export function isOurApiUrl(
  url: string,
  apiEndpoint: string = import.meta.env.VITE_API_ENDPOINT ?? ""
): boolean {
  if (!apiEndpoint) return false;

  if (apiEndpoint.startsWith("http://") || apiEndpoint.startsWith("https://")) {
    return url.startsWith(apiEndpoint);
  }

  try {
    const { pathname } = new URL(url, window.location.origin);
    return pathname === apiEndpoint || pathname.startsWith(`${apiEndpoint}/`);
  } catch {
    return url.startsWith(apiEndpoint);
  }
}

export function transformMapTileRequest(url: string): {
  url: string;
  headers?: Record<string, string>;
} {
  if (!isOurApiUrl(url)) {
    return { url };
  }

  const jwt = window.localStorage.getItem("jwt");
  if (!jwt) {
    return { url };
  }

  return {
    url,
    headers: { Authorization: `Bearer ${jwt}` },
  };
}
